import React from 'react';
import './ContactInfo.css';

const ContactInfo = () => (
  <div className="contact-info">
    <h4 className="contact-info__title">
      <span className="contact-info__icon">📍</span>
      Contact & Location
    </h4>
    
    <div className="contact-item">
      <span className="contact-item__icon">🏠</span>
      <div className="contact-item__content">
        <span className="contact-item__label">Address</span>
        <a 
          href="https://maps.google.com/?q=123+Baby+Lane,+Babyville" 
          target="_blank" 
          rel="noopener noreferrer"
          className="contact-item__value contact-item__link"
        >
          123 Baby Lane, Babyville, 12345
        </a>
      </div>
    </div>

    <div className="contact-item">
      <span className="contact-item__icon">📞</span>
      <div className="contact-item__content">
        <span className="contact-item__label">Phone</span>
        <a href="tel:+11234567890" className="contact-item__value contact-item__link">
          (123) 456-7890
        </a>
      </div>
    </div>

    <div className="contact-item">
      <span className="contact-item__icon">✉️</span>
      <div className="contact-item__content">
        <span className="contact-item__label">Email</span>
        <a href="mailto:info@cozybabycafe.com" className="contact-item__value contact-item__link">
          info@cozybabycafe.com
        </a>
      </div>
    </div>

    <div className="contact-item">
      <span className="contact-item__icon">🌐</span>
      <div className="contact-item__content">
        <span className="contact-item__label">Website</span>
        <a 
          href="https://cozybabycafe.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="contact-item__value contact-item__link"
        >
          cozybabycafe.com
        </a>
      </div>
    </div>

    <div className="contact-socials">
      <a href="#" className="social-btn" title="Facebook">
        <span>📘</span>
      </a>
      <a href="#" className="social-btn" title="Instagram">
        <span>📷</span>
      </a>
      <a href="#" className="social-btn" title="Twitter">
        <span>🐦</span>
      </a>
    </div>
  </div>
);

export default ContactInfo;
